import {configureStore} from '@reduxjs/toolkit';
import rootReducer from './reducers/index'

const store = configureStore({
  reducer: rootReducer, 
  preloadedState: {
    setting: {
      toggle: "LIST", 
      isChangePasswordVisible: false,
      isLoading: false,
      isLoadingCount: 0,
      confirmationDialog: {},
      timePicker: {},
      isLoaderCount: 0,
    },
    isLoaderCount: 0, 
    serviceList: {
      selectedService: {},
      serviceList: [],
      selectedCorporate: null,
      isChangeConfigurationVisible: false,
    }, 
  },
});


export default store;
